import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function Photo() {
    return (
        <>
<FontAwesomeIcon icon="fa-solid fa-image" style={{ color: '#000000', fontSize: '26px', padding:'4px'}} />

  
      
      </>
    )
  }
  
  export default Photo